export default "__VITE_ASSET__CnPyLG3W__"